import { Map } from 'immutable';

export default Map({
  loading: true,
  data: null,
  error: null,
});
